export { default as useClickAnyWhere } from './useClickAnyWhere';
export * from './useClickAnyWhere';
//# sourceMappingURL=index.js.map